/** Tries to resolve a given Promise up to N number of times before throwing. */
export const withRetries = async <T>(
  fn: () => Promise<T>,
  retries = 3,
  delay = 500
): Promise<T> => {
  try {
    return await fn();
  } catch (error) {
    if (retries > 0) {
      await new Promise((resolve) => setTimeout(resolve, delay));
      return withRetries(fn, retries - 1, delay * 2);
    }
    throw error;
  }
};
